<template>  
  <div>
    Fleet Management
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'  
  export default {
   name: 'MissionDetailFleetManagement',   
    data() {
      return {                
      }
   },          
   computed: {
       ...mapGetters([            
         'currentDetailMission'
      ]),     
      mission(){
        return this.currentDetailMission.mission
      }
    },
    methods: {
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  
</style>
